import { render, staticRenderFns } from "./cellDetails.vue?vue&type=template&id=3b147566&"
import script from "./cellDetails.vue?vue&type=script&lang=js&"
export * from "./cellDetails.vue?vue&type=script&lang=js&"
import style0 from "./cellDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VProgressCircular,VTextField})
